export default {
    path: '/',
    name: 'ThirdLogin',
    component: resolve => require(['@/views/thirdLogin'], resolve),
    redirect: '/thirdLogin', 
    children: [
        {
            path: '/thirdLogin',
            name: 'thirdLogin',
            meta: [{
                path: '/thirdLogin',
                title: '首页',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/thirdLogin.vue'], resolve),
        },
    ],
}